module.exports = __webpack_public_path__ + "static/img/Linegrouplogin.eb8570d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Linegrouplogin.svg
// module id = +96B
// module chunks = 1